import PropTypes from "prop-types"
import React, { useState } from "react"
import { useHistory, useLocation } from "react-router"
import styled from "styled-components"

import { useStateValue } from "../../../context/AppStateStore"
import AppSelect from "../../FormItems/AppSelect"

// ----------------------------------------------------------------------------

function _Menu(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className } = props

    const userOptions = [{ value: "logout", label: "Logout" }]

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const { pathname: route } = useLocation()
    const { push } = useHistory()

    const [{ user }, dispatch] = useStateValue()

    const [menuIsActive, setMenuMobileActive] = useState("")

    //const [{ user }] = useStateValue()
    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function toggleMenu() {
        if (menuIsActive == "is-active") {
            setMenuMobileActive("")
        } else {
            setMenuMobileActive("is-active")
        }
    }

    function getActiveClass(href, exact) {
        const condition = exact ? href === route : new RegExp(href).test(route)
        return condition ? "active" : ""
    }

    function navigate(href) {
        return () => {
            if (href) {
                const to = `${getUserAppUrl()}/${href}`
                window.open(to)
            }
        }
    }

    function renderMenuItems() {
        return (
            <>
                <div
                    onClick={navigate(null)}
                    className={`menu-item ${getActiveClass(
                        "/login-agenzia",
                        true
                    )}`}
                >
                    <span className="menu-text bold">{"Sei un'agenzia?"}</span>
                </div>
                {/* ------------------------ */}
                <div
                    onClick={navigate("/come-funziona")}
                    className={`menu-item ${getActiveClass("/come-funziona")}`}
                >
                    <span className="menu-text bold">Come funziona</span>
                </div>
                {/* ------------------------ */}
                <div
                    onClick={navigate("/contatti")}
                    className={`menu-item ${getActiveClass("/contatti")}`}
                >
                    <span className="menu-text bold">Contatti</span>
                </div>
                {/* ------------------------ */}
            </>
        )
    }

    console.log(user)

    function renderUserMenu() {
        return (
            <AppSelect
                options={userOptions}
                className="user-dropdown"
                onChange={userAction}
                placeholder={`Ciao ${
                    user.role === "agency" ? user.businessName : user.fullName
                }`}
            />
        )
    }

    function userAction(action) {
        if (action == "logout") {
            dispatch({
                type: "SIGN_OUT",
            })
        }
    }

    function getUserAppUrl() {
        if (process.env.NODE_ENV === "development") {
            return "http://localhost:3000"
        } else {
            return "https://www.unalloggio.it"
        }
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            <div className="hamburger-wrapper">
                <button
                    className={`hamburger hamburger--squeeze ${menuIsActive}`}
                    type="button"
                    onClick={toggleMenu}
                >
                    <span className="hamburger-box">
                        <span className="hamburger-inner"></span>
                    </span>
                </button>
            </div>
            <div className={`menu-items ${menuIsActive}`}>
                {user ? renderUserMenu() : renderMenuItems()}
            </div>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_Menu.propTypes = {
    className: PropTypes.string.isRequired,
}

_Menu.defaultProps = {}

// ----------------------------------------------------------------------------

const Menu = styled(_Menu)`
    & {
        .hamburger {
            display: none;
            cursor: pointer;
            transition-property: opacity, filter;
            transition-duration: 0.15s;
            transition-timing-function: linear;
            font: inherit;
            color: inherit;
            text-transform: none;
            background-color: transparent;
            border: 0;
            overflow: visible;
            outline: none;
            z-index: 501;
            height: 23px;
            @media screen and (max-width: 992px) {
                display: block;
            }
            &-wrapper {
                display: flex;
                align-items: center;
                height: 100%;
                .label-menu {
                    position: relative;
                    display: block;
                    width: 60px;
                    height: 100%;
                    overflow: hidden;
                    font-family: BlenderPro-Bold, sans-serif;
                    font-size: 18px;
                    line-height: 50px;
                    color: ${(props) => props.theme.colors.light};
                    text-transform: uppercase;
                    margin-right: 12px;
                    & > span {
                        position: absolute;
                        right: 0;
                        transition: opacity 0.3s;
                    }
                    .opened {
                        opacity: 0;
                    }
                    .closed {
                        opacity: 1;
                    }
                }
            }

            &.is-active {
                .hamburger-inner,
                .hamburger-inner::before,
                .hamburger-inner::after {
                    background-color: ${(props) => props.theme.colors.light};
                }
            }
            &-box {
                width: 30px;
                height: 23px;
                display: inline-block;
                position: relative;
            }
            .hamburger-inner {
                display: block;
                top: 50%;
                margin-top: -2px;
                &,
                &::before,
                &::after {
                    width: 30px;
                    height: 2px;
                    background-color: ${(props) => props.theme.colors.dark};
                    position: absolute;
                    transition-property: transform color;
                    transition-duration: 0.15s;
                    transition-timing-function: ease;
                    .image-background & {
                        background-color: ${(props) =>
                            props.theme.colors.light};
                    }
                }
                &::before,
                &::after {
                    content: "";
                    display: block;
                }
                &::before {
                    top: -11px;
                }
                &::after {
                    bottom: -11px;
                }
            }

            &--squeeze {
                .hamburger-inner {
                    transition-duration: 0.075s;
                    transition-timing-function: cubic-bezier(
                        0.55,
                        0.055,
                        0.675,
                        0.19
                    );
                    &::before {
                        transition: top 0.075s 0.12s ease, opacity 0.075s ease;
                    }
                    &::after {
                        transition: bottom 0.075s 0.12s ease,
                            transform 0.075s
                                cubic-bezier(0.55, 0.055, 0.675, 0.19);
                    }
                }
                &.is-active {
                    .hamburger-inner {
                        transform: rotate(45deg);
                        transition-delay: 0.12s;
                        transition-timing-function: cubic-bezier(
                            0.215,
                            0.61,
                            0.355,
                            1
                        );
                        &::before {
                            top: 0;
                            opacity: 0;
                            transition: top 0.075s ease,
                                opacity 0.075s 0.12s ease;
                        }
                        &::after {
                            bottom: 0;
                            transform: rotate(-90deg);
                            transition: bottom 0.075s ease,
                                transform 0.075s 0.12s
                                    cubic-bezier(0.215, 0.61, 0.355, 1);
                        }
                    }
                }
            }
        }
        padding-left: ${(props) => props.theme.spacing.menuSpacing};
        @media screen and (max-width: 992px) {
            padding-left: 0;
        }
        .menu-items {
            display: flex;
            .menu-item {
                font-weight: ${(props) => props.theme.font.weight.bold};
                text-transform: uppercase;
                padding-left: ${(props) => props.theme.spacing.menuSpacing};
                &.active .menu-text {
                    color: ${(props) => props.theme.colors.dark};
                }
                @media screen and (max-width: 992px) {
                    padding-left: ${(props) => props.theme.spacing.padding};
                }
            }
            @media screen and (max-width: 992px) {
                position: fixed;
                left: 0;
                right: 0;
                top: 0;
                height: 0;
                z-index: 101;
                background-color: ${(props) =>
                    props.theme.colors.menuMobileBlackBg};
                flex-direction: column;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                transition: height 0.3s ease-in-out;
                &.is-active {
                    height: 100vh;
                }
                .menu-item {
                    font-size: ${(props) => props.theme.font.title2.size};
                    line-height: ${(props) => props.theme.font.title2.height};
                    padding: ${(props) => props.theme.spacing.padding} 0;
                    color: ${(props) => props.theme.colors.light};
                }
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default Menu
